<template>
    <div class="geo-select">
        <my-multiselect
            v-if="config.select.includes('region')"
            v-model="search.region_id"
            ref="region_multiselect"
            name="region"
            id="input-geo-select-region"
            :options="regions_data"
            :placeholder="lang.section_title.regions | capitalize"
            :clearable="false"
            :disabled="false"
            :allow-empty="false"
            label="name"
            track-by="id"
            @input="changeRegion"
        />

        <my-multiselect
            v-if="config.select.includes('province')"
            v-model="search.province_id"
            ref="province_multiselect"
            name="province"
            id="input-geo-select-province"
            :options="provinces_data"
            :placeholder="lang.section_title.provinces | capitalize"
            :clearable="false"
            :disabled="!provinces_data.length"
            :allow-empty="false"
            label="name"
            track-by="id"
            @input="changeProvince"
        />

         <my-multiselect
            v-if="config.select.includes('city')"
            v-model="search.city_id"
            ref="city_multiselect"
            name="city"
            id="input-geo-select-city"
            :options="cities_data"
            :placeholder="lang.section_title.cities | capitalize"
            :clearable="true"
            :disabled="!cities_data.length"
            :allow-empty="false"
            label="name"
            track-by="id"
            @input="changeCity"
        />

        <my-multiselect
            v-if="config.select.includes('cities')"
            v-model="search.cities"
            ref="city_multiselect"
            name="cities"
            id="input-geo-select-city"
            :options="cities_data"
            :placeholder="lang.section_title.cities | capitalize"
            :clearable="true"
            :disabled="!cities_data.length"
            :allow-empty="false"
            :multiple="true"
            :clear-on-select="false"
            :close-on-select="false"
            :custom-multiselect-label="lang.labels.multiselect_city"
            label="name"
            track-by="id"
            @input="changeCity"
        />

        <my-multiselect
            v-if="config.select.includes('district') && districts_data.length && !isHome"
            v-model="search.district_id"
            ref="district_multiselect"
            name="district"
            id="input-geo-select-district"
            :options="districts_data"
            :placeholder="lang.section_title.districts | capitalize"
            :clearable="true"
            :disabled="false"
            :allow-empty="false"
            label="name"
            track-by="id"
            @input="changeDistrict"
        />

        <my-multiselect
            v-if="config.select.includes('districts') && districts_data.length && !isHome"
            v-model="search.districts"
            ref="district_multiselect"
            name="districts"
            id="input-geo-select-district"
            :options="districts_data"
            :placeholder="lang.section_title.districts | capitalize"
            :clearable="true"
            :disabled="false"
            :allow-empty="false"
            :multiple="true"
            :clear-on-select="false"
            :close-on-select="false"
            :custom-multiselect-label="lang.labels.multiselect_district"
            label="name"
            track-by="id"
            @input="changeDistrict"
        />

        <button
            v-if="isHome"
            @click="setResult"
            class="btn btn-network btn-md"
            :disabled="!searchEnabled"
        ><masked-image class="close-map" src="/img/icons/search.svg"></masked-image></button>

    </div>
</template>

<script>

// import { debounce } from 'lodash'

export default {
    props: {
        config: {
            type: Object,
            required: true,
        },

        contract: {
            type: String,
            default: null,
        },

        cities: {
            type: Array,
            default: null,
        },

        districts: {
            type: Array,
            required: false,
        },

        isHome: {
            type: Boolean,
            default: false,
        },

        searchData: {
            type: Object,
            required: false,
        },

        sector: {
            type: String,
            default: null,
        },

        section: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            cities_data: [],
            districts_data: [],
            provinces_data: [],
            regions_data: [],
            search: {}
        }
    },

    computed: {
        lang() {
            return this.$root.lang.geo_autocomplete
        },

        searchEnabled() {
            if (
                (this.config.select[0] == 'province' && this.search.province_id) ||
                (this.config.select[0] == 'region' && this.search.region_id)
            ) {
                return true
            }

            return false
        }
    },

    created() {
        if (this.config.select[0] == 'province') {
            this.getProvinces()

            if (this.searchData) {
                if (this.config.select.includes('city') || this.config.select.includes('cities')) {
                    this.getCities({province_id: this.searchData.province}, (this.config.select.includes('cities') && this.searchData.cities) ? this.searchData.cities : this.searchData.city)

                    if (this.searchData.city) {
                        if (this.config.select.includes('district') || this.config.select.includes('districts')) {
                            this.getDistricts({city_id: this.searchData.city})
                        }
                    }
                }
            }
        }

        if (this.config.select[0] == 'region') {
            this.getRegions()

            if (this.searchData) {
                if (this.config.select.includes('city') || this.config.select.includes('cities')) {
                    this.getCities({region_id: this.searchData.region}, (this.config.select.includes('cities') && this.searchData.cities) ? this.searchData.cities : this.searchData.city)

                    if (this.searchData.city) {
                        if (this.config.select.includes('district') || this.config.select.includes('districts')) {
                            this.getDistricts({city_id: this.searchData.city})
                        }
                    }
                }
            }
        }
    },

    mounted() {
        window.events.$on('list.geo', geo => {
            if (!geo) {
                if (this.config.select[0] != 'region') {
                    this.regions_data = []
                }
                if (this.config.select[0] != 'province') {
                    this.provinces_data = []
                }
                this.cities_data = []
                this.districts_data = []

                this.search = {}
            } else {
                if (geo.city_id && geo.city_id != this.search.city_id) {
                    let cities_data = this.cities_data
                    this.cities_data = []
                    this.cities_data = cities_data
                    this.search.city_id = geo.city_id
                    this.search.cities = [{id: geo.city_id, name: geo.city_title}]
                    this.search.district_id = null

                    if (this.config.select.includes('district') || this.config.select.includes('districts')) {
                        this.getDistricts({city_id: this.search.city_id})
                    }
                }
                else if (geo.district_id != this.search.district_id) {
                    let districts_data = this.districts_data
                    this.districts_data = []
                    this.districts_data = districts_data
                    this.search.district_id = geo.district_id
                }
            }
        })
    },

    methods: {
        getRegions() {
            axios.get('/api/regions/active')
                .then(({data}) => {
                    this.regions_data = data
                    if (this.searchData.region) {
                        this.search.region_id = this.searchData.region
                    }
                })
                .catch(error => {})
        },

        getProvinces(params = null) {
            axios.get('/api/provinces/active', {params: params})
                .then(({data}) => {
                    this.provinces_data = data
                    if (this.searchData.province) {
                        this.search.province_id = this.searchData.province
                    }
                })
                .catch(error => {})
        },

        getCities(params = null, city = null) {
            axios.get('/api/cities/active', {params: params})
                .then(({data}) => {
                    this.cities_data = data.length ? data : []

                    if (this.config.select.includes('city')) {
                        this.search.city_id = city
                    } else {
                        this.search.cities = []
                        city.toString().split('|').forEach(city_id => {
                            this.cities_data.forEach(cities_data => {
                                if (city_id.toString() == cities_data.id.toString()) {
                                    this.search.cities.push(cities_data)
                                }
                            })
                        })
                    }
                })
                .catch(error => {})
        },

        getDistricts(params = null) {
            axios.get('/api/districts/active', {params: params})
                .then(({data}) => {
                    this.districts_data = data.length ? data : []

                    if (this.config.select.includes('district') && this.searchData.districts) {
                        this.search.district_id = this.searchData.districts
                    } else {
                        this.search.districts = []
                        this.searchData.districts.toString().split('|').forEach(district_id => {
                            this.districts_data.forEach(districts_data => {
                                if (district_id.toString() == districts_data.id.toString()) {
                                    this.search.districts.push(districts_data)
                                }
                            })
                        })
                    }
                })
                .catch(error => {})
        },

        changeRegion() {
            this.provinces_data = []
            this.cities_data = []
            this.districts_data = []

            this.search = {
                results_type: 'geo',
                type: 'region',
                id: this.search.region_id,
                region_id: this.search.region_id,
                province_id: null,
                city_id: null,
                cities: null,
                district_id: null,
                districts: null,
            }

            if (this.config.select.includes('province')) {
                if (this.search.region_id) {
                    this.getProvinces({region_id: this.search.region_id})
                } else {
                    this.provinces_data = []
                }
            }
            else if (this.config.select.includes('city') || this.config.select.includes('cities')) {
                if (this.search.region_id) {
                    this.getCities({region_id: this.search.region_id})
                } else {
                    this.cities_data = []
                }
            }

            if (!this.isHome) this.setResult()
        },

        changeProvince() {
            this.cities_data = []
            this.districts_data = []

            this.search = {
                results_type: 'geo',
                type: 'province',
                id: this.search.province_id,
                region_id: this.search.region_id,
                province_id: this.search.province_id,
                city_id: null,
                cities: null,
                district_id: null,
                districts: null,
            }

            if (this.config.select.includes('city') || this.config.select.includes('cities')) {
                if (this.search.province_id) {
                    this.getCities({province_id: this.search.province_id})
                } else {
                    this.cities_data = []
                }
            }

            if (!this.isHome) this.setResult()
        },

        changeCity() {
            this.districts_data = []

            this.search = {
                results_type: 'geo',
                region_id: this.search.region_id,
                province_id: this.search.province_id,
                city_id: this.search.city_id,
                cities: this.search.cities,
                district_id: null,
                districts: null,
            }

            if (this.config.select.includes('city') && this.search.city_id) {
                this.search.type = 'city'

                this.search.id = this.search.city_id

                if ((this.config.select.includes('district') || this.config.select.includes('districts')) && !this.isHome) {
                    this.getDistricts({city_id: this.search.city_id})
                }
            }
            else if (this.config.select.includes('cities') && this.search.cities) {
                this.search.type = 'city'

                let cities = []
                this.search.cities.forEach(city => {
                    cities.push(city.id)
                })
                this.search.id = cities.join('|')

                if (this.search.cities.length == 1 && (this.config.select.includes('district') || this.config.select.includes('districts')) && !this.isHome) {
                    this.getDistricts({city_id: this.search.cities[0].id})
                }
            } else {
                if (this.config.select.includes('province')) {
                    this.search.type = 'province'
                    this.search.id = this.search.province_id
                }
                if (this.config.select.includes('region')) {
                    this.search.type = 'region'
                    this.search.id = this.search.region_id
                }
            }

            if (!this.isHome) this.setResult()
        },

        changeDistrict() {
            this.search = {
                results_type: 'geo',
                region_id: this.search.region_id,
                province_id: this.search.province_id,
                city_id: this.search.city_id,
                cities: this.search.cities,
                district_id: this.search.district_id,
                districts: this.search.districts,
            }

            if (this.config.select.includes('district') && this.search.district_id) {
                this.search.type = 'districts'
                this.search.id = this.search.district_id
            }
            else if (this.config.select.includes('districts') && this.search.districts) {
                this.search.type = 'districts'

                let districts = []
                this.search.districts.forEach(district => {
                    districts.push(district.id)
                })
                this.search.id = districts.join('|')
            } else {
                this.search.type = 'city'
                this.search.id = this.search.city_id
            }

            if (!this.isHome) this.setResult()
        },

        setResult() {   
            if (this.isHome) {
                isLoading()
            }

            this.$emit('input', this.search)
        }
    },
}
</script>